import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const DiscussionsPage = lazyWithRetry(() =>
  import("@/features/discussion/pages/DiscussionsPage").then((m) => ({ default: m.DiscussionsPage })),
);

export const DISCUSSION_PATH = "/discussions";

const discussionRoutes: RouteConfig[] = [
  {
    path: DISCUSSION_PATH,
    element: <DiscussionsPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default discussionRoutes;
